"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var CardRowNumericEditor_1 = require("../../../../../../shared/components/editors/CardRowNumericEditor");
var BonusFreeSpinRangeGameSetsEditor = /** @class */ (function (_super) {
    __extends(BonusFreeSpinRangeGameSetsEditor, _super);
    function BonusFreeSpinRangeGameSetsEditor(props) {
        return _super.call(this, props) || this;
    }
    BonusFreeSpinRangeGameSetsEditor.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AC = this.props.listAppCurrency.Subscribe("*", function (id, data) {
            _this.setState({
                _currency: data.data
            });
        });
        this.SID_GS = this.props.listGameSet.Subscribe("*", function (id, data) {
            _this.setState({
                _gamesets: data.data
            });
        });
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    amount: _item.min_dep_amount,
                    gameset_id: _item.gameset_id,
                    gameset_title: _item.gameset_title,
                    currency_id: _item.app_currency_id,
                    currency_title: _item.app_currency_iso,
                    description: _item.description,
                    _currency: [],
                    _gamesets: []
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Редактирование элемента набора диапазона фриспинов"]);
                });
            }
        }
        else {
            this.setState({
                amount: 0,
                gameset_id: 0,
                gameset_title: "",
                currency_id: 0,
                currency_title: "",
                description: "",
                _currency: [],
                _gamesets: []
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Создание элемента набора диапазона фриспинов"]);
            });
        }
        this.props.listAppCurrency.LoadData();
        this.doReSetRules();
    };
    BonusFreeSpinRangeGameSetsEditor.prototype.componentWillUnmount = function () {
        this.props.listAppCurrency.UnSubscribe(this.SID_AC);
        this.props.listGameSet.UnSubscribe(this.SID_GS);
    };
    BonusFreeSpinRangeGameSetsEditor.prototype.doReSetRules = function () {
        this.setState({
            amount_rules: { isError: false },
            currency_rules: { isError: false },
            gameset_rules: { isError: false }
        });
    };
    BonusFreeSpinRangeGameSetsEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.amount) || (this.state.amount <= 0)) {
            this.setState({
                amount_rules: { isError: true, errorMessage: "Поле [сумма] не заполнено!" },
            });
            return false;
        }
        if ((this.state.gameset_id <= 0) || (this.state.gameset_title.length === 0)) {
            this.setState({
                gameset_rules: { isError: true, errorMessage: "Поле [набор игр] не выбрано!" },
            });
            return false;
        }
        if ((this.state.currency_id <= 0) || (this.state.currency_title.length === 0)) {
            this.setState({
                gameset_rules: { isError: true, errorMessage: "Поле [валюта] не выбрано!" },
            });
            return false;
        }
        return true;
    };
    BonusFreeSpinRangeGameSetsEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                cms_gameset_id: this.state.gameset_id,
                description: this.state.description,
                min_amount: this.state.amount
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Элемент набора диапазона фриспинов изменен!");
            });
        }
    };
    BonusFreeSpinRangeGameSetsEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                fsrange_id: this.props.rootRecord.key,
                description: this.state.description,
                cms_gameset_id: this.state.gameset_id,
                app_currency_id: this.state.currency_id,
                min_dep_amount: this.state.amount
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Элемент набора диапазона фриспинов добавлен!");
            });
        }
    };
    BonusFreeSpinRangeGameSetsEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    BonusFreeSpinRangeGameSetsEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить элемент набора диапазона фриспинов";
        }
        else {
            return "Изменить элемент набора диапазона фриспинов";
        }
    };
    BonusFreeSpinRangeGameSetsEditor.prototype.getMainContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowNumericEditor_1.default, { texts: {
                    caption: "Мин сумма депозита:",
                    placeholder: "Введите минимальную сумму депозита"
                }, values: {
                    max: 999999999,
                    min: 1,
                    value: this.state.amount
                }, onValueChanged: function (newVal) {
                    _this.setState({
                        amount: newVal,
                        amount_rules: { isError: false }
                    });
                }, rules: this.state.amount_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Валюта:", placeholder: "Выберите валюту" }, value: { key: this.state.currency_id, value: this.state.currency_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        currency_id: newVal.key,
                        currency_title: newVal.value,
                        currency_rules: { isError: false },
                        gameset_id: 0,
                        gameset_title: "",
                        gameset_rules: { isError: false },
                        _gamesets: []
                    }, function () {
                        _this.props.listGameSet.LoadDataByBrandAndCurrency(_this.props.rootRecord.brand_id, _this.state.currency_id);
                    });
                }, items: this.state._currency, disabled: this.props.record != null, required: true, rules: this.state.currency_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Набор игр:", placeholder: "Выберите набор игр" }, value: { key: this.state.gameset_id, value: this.state.gameset_title }, onValueChanged: function (newVal) { _this.setState({ gameset_id: newVal.key, gameset_title: newVal.value, gameset_rules: { isError: false } }); }, items: this.state._gamesets, required: true, rules: this.state.gameset_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.description, onValueChanged: function (newVal) { _this.setState({ description: newVal }); } }),
            this.getDownButtons()));
    };
    BonusFreeSpinRangeGameSetsEditor.prototype.getDownButtons = function () {
        return (React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) }));
    };
    BonusFreeSpinRangeGameSetsEditor.prototype.render = function () {
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 450 }, this.getMainContent()));
    };
    return BonusFreeSpinRangeGameSetsEditor;
}(React.Component));
exports.default = BonusFreeSpinRangeGameSetsEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_fsranges/ui/component/BonusFreeSpinRangeGameSetsEditor.tsx
// module id = 2494
// module chunks = 0